import type { Location } from 'history'
import React from 'react'
import useBrowserBackStack from '../hooks/useBrowserBackStack'

export const RouterBackStackContext = React.createContext<Location[]>([])

export const RouterBackStackProvider = ({
  children,
}: {
  children: React.ReactElement
}): React.ReactElement => {
  const backStack = useBrowserBackStack()

  return (
    <RouterBackStackContext.Provider value={backStack}>
      {children}
    </RouterBackStackContext.Provider>
  )
}
